import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasRole extends EditorEligibilityRule {
  className = 'HasRole';
  operatorName = 'hasRole';

  roles: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.roles = obj?.roles ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return (legacyEligibilityRules?.args?.[1]?.op === 'pick' || legacyEligibilityRules?.args?.[1]?.op === 'get')
      && legacyEligibilityRules?.args?.[1]?.options?.value === 'roles';
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    return new this({
      roles: typeof(legacyEligibilityRules.args[0].options.value) === 'string'
        ? [legacyEligibilityRules.args[0].options.value]
        : legacyEligibilityRules.args[0].options.value
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      roles: serializedValues.roles
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      roles: [{ value: [], disabled: true }]
    };
  }

  createCopy(): EditorEligibilityRuleHasRole {
    return new EditorEligibilityRuleHasRole({
      id: this.id,
      roles: this.roles
    });
  }

  getRolesAsString(roleNames: { id: string, name: string }[]): string {
    if (this.roles.length === 0) { return ''; }
    return this.roles
      .map(role =>
        roleNames.find(roleName => roleName.id === role) ?? { id: role, name: $localize `Not valid` }
      )
      .map(roleName => roleName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      roles: [this.roles]
    };
  }

  getSerializedValues(): any {
    return {
      roles: this.roles
    };
  }
}
